import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "../mocks/homeData";
import { Menu, X, ArrowRight } from "lucide-react";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const handleLogoClick = () => {
    if (isHome) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-white/95 shadow-[0_8px_28px_rgba(15,23,42,0.08)] backdrop-blur-md"
          : "bg-white/85 backdrop-blur-md"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <Link to="/" onClick={handleLogoClick}>
            <img
              src="https://static.readdy.ai/image/b5368476057c9c8f26b27413f3f8af69/80c93b5b5e91db4d90dfa1449ac44727.png"
              alt="Hangar Mühendislik Logo"
              className="h-16 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`font-body text-sm font-medium transition-colors duration-300 hover:text-copper whitespace-nowrap ${
                  location.pathname === link.href ? "text-copper" : "text-navy/85"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/iletisim"
              className="bg-copper hover:bg-copper-dark text-white font-body text-sm font-medium px-5 py-2.5 rounded-md transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap"
            >
              Teklif Al
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "Menüyü kapat" : "Menüyü aç"}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors text-navy bg-white/70 border border-gray-200"
          >
            {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-lg">
          <div className="px-4 py-5 space-y-1.5">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block w-full font-body text-sm font-medium py-3 px-3 rounded-lg hover:bg-gray-50 transition-colors ${
                  location.pathname === link.href ? "text-copper" : "text-navy"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/iletisim"
              className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-copper text-white font-body text-sm font-medium py-3 rounded-lg"
            >
              Teklif Al
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
